// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d9E32ZsfkQ1pW0WQa3pW2{height:50px;line-height:50px;text-align:center}._2VneeyIW5OJOrfesPRE26g,._3k8JhBdd-WTPLXGCW3WVOQ{color:var(--light-color--, #999);font-size:12px}\n", "",{"version":3,"sources":["webpack://src/client/pages/support/pages/order-list-page/fragment/style.module.scss"],"names":[],"mappings":"AAEA,uBACI,WAAY,CACZ,gBAAiB,CACjB,iBAAkB,CACrB,kDAGG,gCAAiC,CACjC,cAAe","sourcesContent":["@import \"../../../../../base.scss\";\n\n.LoadingWrapper{\n    height: 50px;\n    line-height: 50px;\n    text-align: center;\n}\n\n.Loading, .Finished{\n    color: var(--light-color--, #999);\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LoadingWrapper": "d9E32ZsfkQ1pW0WQa3pW2",
	"Loading": "_2VneeyIW5OJOrfesPRE26g",
	"Finished": "_3k8JhBdd-WTPLXGCW3WVOQ"
};
module.exports = ___CSS_LOADER_EXPORT___;
